import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { advicePDFStart } from "Store/advicePDF/slice";
import { ReduxState } from "Store/rootReducer";
import { generatePdfFromBase64EncodedString } from "Utils/fileDownload/fileDownloadUtils";

export interface AdviceScreenshot {
  screenshotRef: HTMLDivElement | null;
  screenshotRefCallback: (node: HTMLDivElement) => void;
  takeScreenshot: (initialAdvice?: boolean) => HTMLDivElement | null;
  setManualScreenshot: (value: boolean) => void;
  screenshotIsLoading: boolean;
}

export const useAdviceScreenshot = (): AdviceScreenshot => {
  const dispatch = useDispatch();
  const { advicePDF } = useSelector((state: ReduxState) => state);
  const [manualScreenshot, setManualScreenshot] = useState(false);
  const [screenshotRef, setScreenshotRef] = useState<HTMLDivElement | null>(
    null,
  );
  const screenshotRefCallback = useCallback((node: HTMLDivElement) => {
    setScreenshotRef(node);
  }, []);

  const takeScreenshot = useCallback(
    (initialAdvice?: boolean) => {
      if (initialAdvice) {
        dispatch(
          advicePDFStart({
            ref: screenshotRef,
            initialAdvice,
            throwNewError: false,
          }),
        );
        return null;
      }
      return screenshotRef;
    },
    [screenshotRef],
  );

  useEffect(() => {
    if (advicePDF.response.current && manualScreenshot) {
      const fileURL = generatePdfFromBase64EncodedString(
        advicePDF.response.current.payload.pdf,
      );
      window.open(fileURL, "_blank");
      setManualScreenshot(false);
    }
  }, [advicePDF.response.current]);

  return {
    screenshotRef,
    screenshotRefCallback,
    takeScreenshot,
    setManualScreenshot,
    screenshotIsLoading: advicePDF.response.isLoading,
  };
};
